<template>
  <div class="results">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <div class="stats small">
        <div class="card" @click="hideFilters()">
          <p class="stat">
            {{ surveyCounts.completed_count }}
            <span>Completed Surveys</span>
          </p>
        </div>
        <div
          class="card card-filter"
          :class="incomplete_filter ? 'incomplete-filter' : null"
          @click="showIncomplete()"
        >
          <p class="stat">
            {{ surveyCounts.incomplete_count }}
            <span>Incomplete Employee Surveys</span>
          </p>
        </div>
        <div class="card">
          <p class="stat">
            {{ surveyCounts.pass_count }}
            <span>Passed Surveys</span>
          </p>
        </div>
        <div
          class="card card-filter"
          :class="failed_filter ? 'failed-filter' : null"
          @click="showFailed()"
        >
          <p class="stat">
            {{ surveyCounts.fail_count }}
            <span>Failed Surveys</span>
          </p>
        </div>
      </div>
      <div class="card filters">
        <div class="date-range-container">
          <div class="filter">
            <label>Start Date</label>
            <datepicker
              placeholder="Custom Date"
              v-model="startDate"
              name="uniquename"
              ref="datepicker"
              :full-month-name="true"
              :disabled-dates="custom_date.disabled"
            ></datepicker>
          </div>
          <div class="filter">
            <label>End Date</label>
            <datepicker
              placeholder="Custom Date"
              v-model="endDate"
              name="uniquename"
              ref="datepicker"
              :full-month-name="true"
              :disabled-dates="custom_date.disabled"
            ></datepicker>
          </div>
          <div class="filter_button">
            <button class="btn round-btn" @click="fetchNewAnalytics">
              Filter
            </button>
            <template v-if="user_doc.id == 'w4h3Dd6J2GbLshKkroP9jnCZKfj2'">
              <button
                @click="exportReport('daily_activity')"
                class="btn active"
              >
                Daily Activity (Checkins)
              </button>
              <button @click="exportReport('no_reminders')" class="btn active">
                No Scheduled Reminders
              </button>
              <button @click="exportReport('opt_outs')" class="btn active">
                Opt Outs
              </button>
              <button
                @click="exportReport('deliveryStatus')"
                class="btn active"
              >
                Delivery Status
              </button>
            </template>
          </div>
        </div>
        <div class="inputs survey-forms" v-if="locations && locations.length">
          <div class="inputs survey-forms divide">
            <div class="input full">
              <label>Filter by Location</label>
              <v-select
                :options="locations"
                label="name"
                :clearable="false"
                :reduce="
                  (d) => {
                    return { id: d.id, name: d.name };
                  }
                "
                v-model="filter_values.location"
                @input="filterResultsByLocation()"
              >
                <template v-slot:option="option">
                  <div>
                    {{
                      `${option.name} - ${option.address_1}, ${option.city}, ${option.state}`
                    }}
                  </div>
                </template>
              </v-select>
            </div>
          </div>
          <div class="inputs survey-forms">
            <button
              v-if="showClearBtn"
              @click="clearFilter"
              class="btn round-btn red clear"
            >
              Clear Filter
            </button>
          </div>
        </div>
      </div>
      <div class="chart_view card">
        <div class="chart_container">
          <div class="chart2-label">
            <p class="stat">
              <span>Completed Surveys</span>
            </p>
            <div class="legend">
              <div class="key">
                <div class="color" style="background-color: #00bf6f"></div>
                <p class="pass">Pass</p>
              </div>
              <div class="key">
                <div class="color" style="background-color: #f44336"></div>
                <p style="color: red">Fail</p>
              </div>
            </div>
          </div>
          <div class="ct-chart ct-golden-section" id="chart2"></div>
        </div>
      </div>
      <div class="chart_view card">
        <div class="chart_container">
          <div class="chart2-label">
            <p class="stat">
              <span>Failed Surveys</span>
            </p>
          </div>
          <div class="ct-chart ct-golden-section" id="chart1"></div>
        </div>
      </div>
      <div class="card">
        <p class="title">
          Your Reports
          <button
            v-if="user_doc.id == 't8C81NljrBRwzeBhWsbYueJzK1Y2'"
            @click="exportVaccineResponses"
            class="btn round-btn small"
          >
            Export Vaccine Survey Results
          </button>
          <button @click="inputFileToExport" class="btn round-btn small">
            Export
          </button>
        </p>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th v-if="incomplete_filter">Survey Sent (Email)</th>
              <th v-if="incomplete_filter">Survey Sent (Text)</th>
              <th v-else>Submitted</th>
              <th class="status-filter" v-if="!incomplete_filter">
                Status
                <img
                  @click="sort(!status_filter)"
                  class="filter-icon"
                  :class="status_filter ? 'down-arrow' : null"
                  src="@/assets/img/sort-arrow.svg"
                />
              </th>
              <th
                v-if="filter_time == filter_dates.today && !incomplete_filter"
              >
                Employee Completed Survey
              </th>
              <th>Location</th>
            </tr>
          </thead>
          <tbody v-if="results">
            <template v-for="(item, i) in results">
              <tr :key="i" :class="{ grey: i % 2 }">
                <td data-label="Name">
                  {{ item.First_Name + " " + item.Last_Name }}
                </td>
                <td data-label="Submitted" v-if="item.Survey_Time">
                  {{ getSubmittedDate(item.Survey_Time) }}
                </td>
                <td v-if="incomplete_filter" data-label="Email">
                  <img
                    v-if="item.Email"
                    class="action clickable"
                    src="@/assets/img/check.svg"
                  />
                  <img
                    v-else
                    class="action clickable"
                    src="@/assets/img/delete.svg"
                  />
                </td>
                <td v-if="incomplete_filter" data-label="Text">
                  <img
                    v-if="item.Text"
                    class="action clickable"
                    src="@/assets/img/check.svg"
                  />
                  <img
                    v-else
                    class="action clickable"
                    src="@/assets/img/delete.svg"
                  />
                </td>
                <td
                  v-if="
                    !incomplete_filter &&
                    (item.Pre_Question_Answer === 'I am going into work.' ||
                      !item.Pre_Question_Answer)
                  "
                  data-label="Pass/Fail"
                >
                  <img
                    v-if="item.Passed === 'true'"
                    class="action clickable"
                    src="@/assets/img/check.svg"
                  />
                  <img
                    v-else
                    class="action clickable"
                    src="@/assets/img/delete.svg"
                  />
                </td>
                <td v-else>
                  <p>
                    {{ formatPQA(item.Pre_Question_Answer) }}
                  </p>
                </td>
                <td
                  v-if="filter_time == filter_dates.today && !incomplete_filter"
                  data-label="Employee Completed Survey"
                >
                  <span v-if="item.Date || item.Passed">
                    <img
                      class="action clickable"
                      style="cursor: default"
                      src="@/assets/img/check.svg"
                    />
                  </span>
                  <img
                    v-else
                    class="action clickable"
                    style="cursor: default"
                    src="@/assets/img/delete.svg"
                  />
                </td>
                <td>{{ item.Location }}</td>
              </tr>
            </template>
          </tbody>
        </table>
        <p v-if="filter_error" class="filter_error">
          {{ filter_error }}
        </p>
        <div class="pagination">
          <p v-if="!incomplete_filter && !failed_filter">
            {{ start }} - {{ end }} of
            {{ pageCount.resultsPageCount }}
          </p>
          <p v-else-if="failed_filter">
            {{ start }} - {{ end }} of
            {{ pageCount.failedPageCount }}
          </p>
          <p v-else-if="incomplete_filter">
            {{ start }} - {{ end }} of
            {{ pageCount.incompletePageCount }}
          </p>
          <div
            class="action prev"
            :class="{ inactive: pageNumber === 1 }"
            @click="firstPage"
          >
            <img src="@/assets/img/dark_arr.svg" />
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <div
            class="action prev"
            :class="{ inactive: pageNumber === 1 }"
            @click="prevPage"
          >
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <div
            class="action next"
            :class="{
              inactive: getPaginationInactive(),
            }"
            @click="nextPage"
          >
            <img src="@/assets/img/dark_arr.svg" />
          </div>
          <div
            class="action next"
            :class="{
              inactive: getPaginationInactive(),
            }"
            @click="lastPage"
          >
            <img src="@/assets/img/dark_arr.svg" />
            <img src="@/assets/img/dark_arr.svg" />
          </div>
        </div>
      </div>
    </div>
    <popup :showPopup="showPopup">
      <template>
        <p class="title">Enter the email you will like to send this file to.</p>
        <div class="inputs survey-forms">
          <div class="input full btm-space">
            <input
              v-model="email"
              type="email"
              placeholder="Type Email Here..."
            />
            <button @click="sendCSV">Send</button>
          </div>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
import Register from "@/components/Register";
import firebase from "firebase";
import Switches from "vue-switches";
import moment from "moment-timezone";
import Datepicker from "vuejs-datepicker";
import Popup from "@/components/Popup.vue";
import Swal from "sweetalert2";
import * as mappers from "../utilities/mapper.js";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
const functions = fb.default.functions;

export default {
  name: "results",
  components: {
    register: Register,
    Switches,
    Datepicker,
    popup: Popup,
  },
  data() {
    return {
      custom_date: {
        date: null,
        disabled: {
          from: new Date(moment().add(1, "day").valueOf()),
        },
      },
      filter_dates: {
        all: null,
        today: moment().startOf("day").valueOf(),
        yesterday: moment().subtract(1, "day").startOf("day").valueOf(),
        past_2_days: moment().subtract(2, "days").startOf("day").valueOf(),
        past_week: moment().subtract(1, "week").startOf("day").valueOf(),
      },
      status_filter: true,
      incomplete_filter: false,
      failed_filter: false,
      details: null,
      client: null,
      email: null,
      employees: [],
      filter_error: null,
      filter_active: null,
      showPopup: false,
      downloadLink: null,
      exportCSV: functions.httpsCallable("exportReportCSV"),
      sendEmail: functions.httpsCallable("sendEmail"),
      getIncompleteSurveysCount: functions.httpsCallable(
        "getIncompleteSurveysCount"
      ),
      getReportingResults: functions.httpsCallable(
        "reporting-getReportingResults"
      ),
      getReportingResultsCounts: functions.httpsCallable(
        "reporting-getReportingResultsCounts"
      ),
      getReportingIncompleteList: functions.httpsCallable(
        "reporting-getReportingIncompleteList"
      ),
      getReportingEmployeesFailed: functions.httpsCallable(
        "reporting-getReportingEmployeesFailed"
      ),
      getVaccineSurveyResults: functions.httpsCallable(
        "reporting-getVaccineSurveyResults"
      ),
      results: [],
      filter_values: {},
      page_size: 10,
      pageNumber: 0,
      start: 0,
      end: 0,
      resultsLength: 0,
      unfilteredResults: [],
      surveyCounts: {
        completed_count: 0,
        pass_count: 0,
        fail_count: 0,
        incomplete_count: 0,
      },
      showClearBtn: false,
      startDate: new Date(),
      endDate: new Date(),
    };
  },
  mounted() {
    let loader = this.$loading.show({
      container: null,
      canCancel: false,
    });
    this.getReportingResultsCounts({
      uid: this.user_doc.id,
      start_date: moment(this.startDate).format("YYYY-MM-DD"),
      end_date: moment(this.endDate).format("YYYY-MM-DD"),
      location: this.filter_values.location
        ? this.filter_values.location.name
        : null,
    }).then((res) => {
      this.surveyCounts = {
        completed_count: res.data.completed,
        pass_count: res.data.pass,
        fail_count: res.data.fail,
        incomplete_count: res.data.incomplete,
      };
    });
    this.getReportingResults({
      uid: this.user_doc.id,
      start_date: moment(this.startDate).format("YYYY-MM-DD"),
      end_date: moment(this.endDate).format("YYYY-MM-DD"),
      limit: 10,
      page: 1,
      location: this.filter_values.location
        ? this.filter_values.location.name
        : null,
    }).then((res) => {
      this.results = res.data;
      this.pageNumber = 1;
      this.start = 1;
      this.end = 10;
    });
    this.getReportingResults({
      uid: this.user_doc.id,
      start_date: moment(this.startDate).format("YYYY-MM-DD"),
      end_date: moment(this.endDate).format("YYYY-MM-DD"),
      location: this.filter_values.location
        ? this.filter_values.location.name
        : null,
    }).then((res) => {
      this.resultsLength = res.data.length;
      this.$nextTick(async () => {
        new Chartist.Line(
          "#chart1",
          mappers.failedSurveysMapper(res.data, this.startDate, this.endDate),
          {
            axisY: {
              onlyInteger: true,
            },
          }
        );

        new Chartist.Bar(
          "#chart2",
          mappers.completedSurveysMapper(
            res.data,
            this.startDate,
            this.endDate
          ),
          {
            axisY: {
              onlyInteger: true,
            },
          }
        );
      });
      loader.hide();
    });
  },
  computed: {
    pageCount() {
      let incomplete = this.surveyCounts.incomplete_count;
      let failed = this.surveyCounts.fail_count;
      let s = this.page_size;
      return {
        resultsPageCount: this.resultsLength,
        incompletePageCount:
          incomplete < 10 ? incomplete : Math.ceil(incomplete / s),
        failedPageCount: failed < 10 ? failed : Math.ceil(failed / s),
      };
    },
    filter_time: {
      get() {
        if (this.custom_date.date) {
          return moment(this.custom_date.date).valueOf();
        } else {
          return null;
        }
      },
      set(val) {
        if (val == null) {
          this.custom_date.date = null;
        } else {
          this.custom_date.date = new Date(val);
        }
      },
    },
  },
  watch: {
    filter_values: {
      handler(val) {
        if (Object.keys(val).length) this.showClearBtn = true;
      },
      deep: true,
    },
  },
  async created() {
    let loader = this.$loading.show({
      container: null,
      canCancel: false,
    });
    await Promise.all([
      this.$bind("client", db.collection("user").doc(this.user_doc.id)),
      this.$bind(
        "locations",
        db
          .collection("user")
          .doc(this.user_doc.id)
          .collection("locations")
          .orderBy("name", "asc")
      ),
    ]);
    loader.hide();
  },
  methods: {
    async exportVaccineResponses() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      const locationIDs = this.locations
        .filter((l) => l.state == "California")
        .map((i) => i.id);

      this.getVaccineSurveyResults({
        locationIDs: locationIDs,
      })
        .then((res) => {
          let results = res.data;
          const header = `Name,Employee#,Submmited,Location,Interested In Vaccine,Department,Work Site,Taken The Vaccine,Presented Vaccine To HR\n`;
          let csvStr = "";
          for (const key in results) {
            const result = results[key];
            let interestedInVaccine = "No";
            let vaccinated = "No";
            let presentedToHR = "No";

            if (result.results.interestedInRecevingVaccine) {
              interestedInVaccine = "Yes";
            }

            if (result.results.vaccinatedThroughWonderful) {
              vaccinated = "Vaccinated Through Wonderful";
              presentedToHR = "Yes";
            }

            if (result.results.presentedVaccinationToHR) {
              presentedToHR = "Yes";
              vaccinated = "Yes"
            }

            csvStr += `${result.name},${result.employee_num},${result.submmited},${
              result.location
            },${interestedInVaccine},${
              result.results.department ? result.results.department : ""
            },${
              result.results.workSite ? result.results.workSite : ""
            },${vaccinated},${presentedToHR}\n`;
          }
          let csvContent = header + csvStr;

          var encodedUri = encodeURI(csvContent);
          var csvData = new Blob([csvContent], { type: "text/csv" }); //new way
          var csvUrl = URL.createObjectURL(csvData);

          var link = document.createElement("a");
          link.setAttribute("href", csvUrl);
          link.setAttribute("download", `Vaccine Survey Results.csv`);
          document.body.appendChild(link); // Required for FF
          loader.hide();
          link.click();
        })
        .catch((err) => {
          loader.hide();
          console.log(err);
        });
    },
    exportReport(report_name) {
      let url = "";

      switch (report_name) {
        case "daily_activity":
          url = "exportDailyActivity";
          break;
        case "no_reminders":
          url = "exportNoScheduledReminders";
          break;
        case "opt_outs":
          url = "exportOptOuts";
          break;
        case "deliveryStatus":
          url = "exportDeliveryStatus";
          break;
      }
      window.open(
        `https://us-central1-covid19pad-672e5.cloudfunctions.net/cmh_reporting-${url}?client_id=${
          this.user_doc.id
        }&start_date=${moment(this.startDate).format(
          "YYYY-MM-DD"
        )}&end_date=${moment(this.endDate).format("YYYY-MM-DD")}`,
        "_blank"
      );
    },
    handleCheckIn(date) {
      if (!date) return false;
      let today = moment().startOf("day").valueOf();
      let last_checked_in = moment(date).startOf("day").valueOf();
      return today == last_checked_in;
    },
    handleEdit(item) {
      this.$router.push(`results/${item.form_id}/${item.id}`);
    },
    newForm() {
      let id = db.collection("form").doc().id;
      this.goTo("/form/" + id);
    },
    formatDateTime(timestamp) {
      return moment(timestamp).format("MM/DD/YYYY hh:mm a");
    },
    inputFileToExport() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });

      loader.hide();
      Swal.fire({
        title: "How you want to handle this file?",
        text: "Would you like to download on your pc or send via email?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "DOWNLOAD",
        cancelButtonText: "SEND VIA EMAIL",
      }).then((result) => {
        let downloadLink;
        if (result.value) {
          if (this.incomplete_filter) {
            downloadLink = `https://us-central1-covid19pad-672e5.cloudfunctions.net/reporting-exportIncomplete?uid=${
              this.user_doc.id
            }&start_date=${moment(this.startDate).format(
              "YYYY-MM-DD"
            )}&end_date=${moment(this.endDate).format("YYYY-MM-DD")}${
              this.filter_values.location
                ? `&location=${this.filter_values.location.name}`
                : ``
            }`;
            window.open(downloadLink, "_blank");
            loader.hide();
          } else if (this.failed_filter) {
            downloadLink = `https://us-central1-covid19pad-672e5.cloudfunctions.net/reporting-exportFailed?uid=${
              this.user_doc.id
            }&start_date=${moment(this.startDate).format(
              "YYYY-MM-DD"
            )}&end_date=${moment(this.endDate).format("YYYY-MM-DD")}`;
            window.open(downloadLink, "_blank");
            loader.hide();
          } else {
            downloadLink = `https://us-central1-covid19pad-672e5.cloudfunctions.net/reporting-exportFull?uid=${
              this.user_doc.id
            }&start_date=${moment(this.startDate).format(
              "YYYY-MM-DD"
            )}&end_date=${moment(this.endDate).format("YYYY-MM-DD")}`;
            window.open(downloadLink, "_blank");
            loader.hide();
          }
        } else if (result.dismiss == "cancel") {
          this.downloadLink = downloadLink;
          this.showPopup = true;
        }
      });
    },
    sendCSV() {
      this.showPopup = false;
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      this.sendEmail({
        template_name: "covid19-user-reports",
        from_email: null,
        to_email: [
          {
            email: this.email,
            type: "to",
          },
        ],
        attachments: [
          {
            type: "text/csv",
            name: `${this.client.name}-Reports.csv`,
            content: this.downloadLink,
          },
        ],
        message: null,
      }).then(() => {
        loader.hide();
        Swal.fire("Email Has Been Sent!");
      });
    },
    filterResultsByLocation() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      if (this.filter_time) {
        this.getReportingResults({
          uid: this.user_doc.id,
          start_date: moment(this.startDate).format("YYYY-MM-DD"),
          end_date: moment(this.endDate).format("YYYY-MM-DD"),
          page: 1,
          limit: this.page_size,
          location: this.filter_values.location.name,
        }).then((res) => {
          this.results = res.data;
          this.pageNumber = 1;
          this.start = 1;
          this.end = 10;
          loader.hide();
        });
      } else {
        this.getReportingResults({
          uid: this.user_doc.id,
          start_date: null,
          end_date: null,
          page: 1,
          limit: this.page_size,
          location: this.filter_values.location.name,
        }).then((res) => {
          this.results = res.data;
          this.pageNumber = 1;
          this.start = 1;
          this.end = 10;
          loader.hide();
        });
      }
    },
    hasCompleteSurvey(id) {
      if (this.filter_time === this.filter_dates.today) {
        let responseByEmployee = {};
        for (let response in this.results) {
          if (!responseByEmployee[this.results[response].employee_id]) {
            responseByEmployee[
              this.results[response].employee_id
            ] = this.results[response];
          }
        }
        if (responseByEmployee[id]) {
          let today = moment().format("YYYY-MM-DD");
          let responseDate = moment(responseByEmployee[id].created_at).format(
            "YYYY-MM-DD"
          );
          if (responseDate === today) return true;
          else return false;
        } else return false;
      }
    },
    getSubmittedDate(date) {
      if (date.value) return moment(date.value).format("MM/DD/YYYY HH:mm A");
      else return moment(date).format("MM/DD/YYYY HH:mm A");
    },
    sort() {
      let sortedResults = this.results.sort((x, y) => {
        if (this.status_filter) {
          return x.status === y.status ? 0 : x.status ? -1 : 1;
        } else {
          return x.status === y.status ? 0 : x.status ? 1 : -1;
        }
      });
      this.results = sortedResults;
      this.status_filter = !this.status_filter;
    },
    showFailed() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      if (!this.incomplete_filter) {
        if (!this.failed_filter) {
          this.failed_filter = true;
          this.pageCount.resultsPageCount = Math.floor(
            this.surveyCounts.fail_count / this.page_size
          );
          this.getReportingEmployeesFailed({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: 1,
            location: this.filter_values.location
              ? this.filter_values.location.name
              : null,
          }).then((res) => {
            this.results = res.data;
            this.pageNumber = 1;
            this.start = 1;
            this.end = 10;
            loader.hide();
          });
        } else {
          this.failed_filter = false;
          this.getReportingResults({
            uid: this.user_doc.id,
            start_date: moment(this.dtartDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: 10,
            page: 1,
            location: this.filter_values.location
              ? this.filter_values.location.name
              : null,
          }).then((res) => {
            this.results = res.data;
            this.pageNumber = 1;
            this.start = 1;
            this.end = 10;
            loader.hide();
          });
        }
      }
    },
    hideFilters() {
      if (this.failed_filter || this.incomplete_filter) {
        let loader = this.$loading.show({
          container: null,
          canCancel: false,
        });
        this.failed_filter = false;
        this.incomplete_filter = false;
        this.getReportingResultsCounts({
          uid: this.user_doc.id,
          start_date: moment(this.startDate).format("YYYY-MM-DD"),
          end_date: moment(this.endDate).format("YYYY-MM-DD"),
          location: this.filter_values.location
            ? this.filter_values.location.name
            : null,
        }).then((res) => {
          this.surveyCounts = {
            completed_count: res.data.completed,
            pass_count: res.data.pass,
            fail_count: res.data.fail,
            incomplete_count: res.data.incomplete,
          };
        });
        this.getReportingResults({
          uid: this.user_doc.id,
          start_date: moment(this.startDate).format("YYYY-MM-DD"),
          end_date: moment(this.endDate).format("YYYY-MM-DD"),
          limit: 10,
          page: 1,
          location: this.filter_values.location
            ? this.filter_values.location.name
            : null,
        }).then((res) => {
          this.results = res.data;
          this.pageNumber = 1;
          this.start = 1;
          this.end = 10;
        });
        this.getReportingResults({
          uid: this.user_doc.id,
          start_date: moment(this.startDate).format("YYYY-MM-DD"),
          end_date: moment(this.endDate).format("YYYY-MM-DD"),
          location: this.filter_values.location
            ? this.filter_values.location.name
            : null,
        }).then((res) => {
          this.resultsLength = res.data.length;
          this.$nextTick(async () => {
            new Chartist.Line(
              "#chart1",
              mappers.failedSurveysMapper(
                res.data,
                this.startDate,
                this.endDate
              ),
              {
                axisY: {
                  onlyInteger: true,
                },
              }
            );

            new Chartist.Bar(
              "#chart2",
              mappers.completedSurveysMapper(
                res.data,
                this.startDate,
                this.endDate
              ),
              {
                axisY: {
                  onlyInteger: true,
                },
              }
            );
          });
          loader.hide();
        });
      }
    },
    showIncomplete() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      if (!this.failed_filter) {
        if (!this.incomplete_filter) {
          this.incomplete_filter = true;
          this.pageCount.resultsPageCount = Math.floor(
            this.surveyCounts.incomplete_count / this.page_size
          );
          this.getReportingIncompleteList({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: 1,
            location: this.filter_values.location
              ? this.filter_values.location.name
              : null,
          }).then((res) => {
            this.results = res.data;
            this.pageNumber = 1;
            this.start = 1;
            this.end = 10;
            loader.hide();
          });
        } else {
          this.incomplete_filter = false;
          this.getReportingResults({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: 10,
            page: 1,
            location: this.filter_values.location
              ? this.filter_values.location.name
              : null,
          }).then((res) => {
            this.results = res.data;
            this.pageNumber = 1;
            this.start = 1;
            this.end = 10;
            loader.hide();
          });
        }
      }
    },
    nextPage() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      if (this.filter_values.location) {
        if (this.failed_filter) {
          this.getReportingEmployeesFailed({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: this.pageNumber + 1,
            location: this.filter_values.location
              ? this.filter_values.location.name
              : null,
          }).then((res) => {
            this.results = res.data;
            this.pageNumber = this.pageNumber + 1;
            this.start = this.start + 10;
            this.end = this.end + 10;
            loader.hide();
          });
        } else if (this.incomplete_filter) {
          this.getReportingIncompleteList({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: this.pageNumber + 1,
            limit: 10,
            location: this.filter_values.location
              ? this.filter_values.location.name
              : null,
          }).then((res) => {
            this.results = res.data;
            this.pageNumber = this.pageNumber + 1;
            this.start = this.start + 10;
            this.end = this.end + 10;
            loader.hide();
          });
        } else {
          this.getReportingResultsByLocation({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            page: this.pageNumber + 1,
            limit: this.page_size,
            location: this.filter_values.location.name,
          }).then((res) => {
            this.results = res.data;
            this.start = this.start + 10;
            this.end = this.end + 10;
            this.pageNumber = this.pageNumber + 1;
            loader.hide();
          });
        }
      } else {
        if (this.failed_filter) {
          this.getReportingEmployeesFailed({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: this.pageNumber + 1,
          }).then((res) => {
            this.results = res.data;
            this.pageNumber = this.pageNumber + 1;
            this.start = this.start + 10;
            this.end = this.end + 10;
            loader.hide();
          });
        } else if (this.incomplete_filter) {
          this.getReportingIncompleteList({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: this.pageNumber + 1,
            location: this.filter_values.location
              ? this.filter_values.location.name
              : null,
          }).then((res) => {
            this.results = res.data;
            this.pageNumber = this.pageNumber + 1;
            this.start = this.start + 10;
            this.end = this.end + 10;
            loader.hide();
          });
        } else {
          this.getReportingResults({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            page: this.pageNumber + 1,
            limit: this.page_size,
          }).then((res) => {
            this.results = res.data;
            this.start = this.start + 10;
            this.end = this.end + 10;
            this.pageNumber = this.pageNumber + 1;
            loader.hide();
          });
        }
      }
    },
    prevPage() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      if (this.filter_values.location) {
        if (this.failed_filter) {
          this.getReportingEmployeesFailed({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: this.pageNumber - 1,
            location: this.filter_values.location
              ? this.filter_values.location.name
              : null,
          }).then((res) => {
            this.results = res.data;
            this.pageNumber = this.pageNumber - 1;
            this.start = this.start - 10;
            this.end = this.end - 10;
            loader.hide();
          });
        } else if (this.incomplete_filter) {
          this.getReportingIncompleteList({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: this.pageNumber - 1,
            limit: this.page_size,
            location: this.filter_values.location
              ? this.filter_values.location.name
              : null,
          }).then((res) => {
            this.results = res.data;
            this.pageNumber = this.pageNumber - 1;
            this.start = this.start - 10;
            this.end = this.end - 10;
            loader.hide();
          });
        } else {
          this.getReportingResultsByLocation({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            page: this.pageNumber - 1,
            limit: this.page_size,
            location: this.filter_values.location.name,
          }).then((res) => {
            this.results = res.data;
            this.start = this.start - 10;
            this.end = this.start - 10;
            this.pageNumber = this.pageNumber - 1;
            loader.hide();
          });
        }
      } else {
        if (this.failed_filter) {
          this.getReportingEmployeesFailed({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: this.pageNumber - 1,
          }).then((res) => {
            this.results = res.data;
            this.pageNumber = this.pageNumber - 1;
            this.start = this.start - 10;
            this.end = this.end - 10;
            loader.hide();
          });
        } else if (this.incomplete_filter) {
          this.getReportingIncompleteList({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: this.pageNumber - 1,
            location: this.filter_values.location
              ? this.filter_values.location.name
              : null,
          }).then((res) => {
            this.results = res.data;
            this.pageNumber = this.pageNumber - 1;
            this.start = this.start - 10;
            this.end = this.end - 10;
            loader.hide();
          });
        } else {
          this.getReportingResults({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            page: this.pageNumber - 1,
            limit: this.page_size,
          }).then((res) => {
            this.results = res.data;
            this.start = this.start - 10;
            this.end = this.end - 10;
            this.pageNumber = this.pageNumber - 1;
            loader.hide();
          });
        }
      }
    },
    firstPage() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      if (this.filter_values.location) {
        if (this.failed_filter) {
          this.getReportingEmployeesFailed({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: 1,
            location: this.filter_values.location
              ? this.filter_values.location.name
              : null,
          }).then((res) => {
            this.results = res.data;
            this.pageNumber = 1;
            this.start = 1;
            this.end = 10;
            loader.hide();
          });
        } else if (this.incomplete_filter) {
          this.getReportingIncompleteList({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: 1,
            limit: this.page_size,
            location: this.filter_values.location
              ? this.filter_values.location.name
              : null,
          }).then((res) => {
            this.results = res.data;
            this.pageNumber = 1;
            this.start = 1;
            this.end = 10;
            loader.hide();
          });
        } else {
          this.getReportingResultsByLocation({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            page: 1,
            limit: this.page_size,
            location: this.filter_values.location.name,
          }).then((res) => {
            this.results = res.data;
            this.start = 1;
            this.end = 10;
            this.pageNumber = 1;
            loader.hide();
          });
        }
      } else {
        if (this.failed_filter) {
          this.getReportingEmployeesFailed({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: 1,
            location: this.filter_values.location
              ? this.filter_values.location.name
              : null,
          }).then((res) => {
            this.results = res.data;
            this.pageNumber = 1;
            this.start = 1;
            this.end = 10;
            loader.hide();
          });
        } else if (this.incomplete_filter) {
          this.getReportingIncompleteList({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: 1,
            location: this.filter_values.location
              ? this.filter_values.location.name
              : null,
          }).then((res) => {
            this.results = res.data;
            this.pageNumber = 1;
            this.start = 1;
            this.end = 10;
            loader.hide();
          });
        } else {
          this.getReportingResults({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            page: 1,
            limit: this.page_size,
          }).then((res) => {
            this.results = res.data;
            this.start = 1;
            this.end = 10;
            this.pageNumber = 1;
            loader.hide();
          });
        }
      }
    },
    lastPage() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      if (this.filter_values.location) {
        if (this.failed_filter) {
          this.getReportingEmployeesFailed({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: Math.floor(this.pageCount.failedPageCount / this.page_size),
            location: this.filter_values.location
              ? this.filter_values.location.name
              : null,
          }).then((res) => {
            this.results = res.data;
            this.start =
              Math.floor(this.pageCount.failedPageCount / this.page_size) - 10;
            this.end = Math.floor(
              this.pageCount.failedPageCount / this.page_size
            );
            this.pageNumber = Math.floor(
              this.pageCount.failedPageCount / this.page_size
            );
            loader.hide();
          });
        } else if (this.incomplete_filter) {
          this.getReportingIncompleteList({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: Math.floor(
              this.pageCount.incompletePageCount / this.page_size
            ),
            limit: this.page_size,
            location: this.filter_values.location
              ? this.filter_values.location.name
              : null,
          }).then((res) => {
            this.results = res.data;
            this.start =
              Math.floor(this.pageCount.incompletePageCount / this.page_size) -
              10;
            this.end = Math.floor(
              this.pageCount.incompletePageCount / this.page_size
            );
            this.pageNumber = Math.floor(
              this.pageCount.incompletePageCount / this.page_size
            );
            loader.hide();
          });
        } else {
          this.getReportingResultsByLocation({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            page: Math.floor(this.resultsLength / this.page_size),
            limit: this.page_size,
            location: this.filter_values.location.name,
          }).then((res) => {
            this.results = res.data;
            this.start = Math.floor(this.resultsLength / this.page_size) - 10;
            this.end = Math.floor(this.resultsLength / this.page_size);
            this.pageNumber = Math.floor(this.resultsLength / this.page_size);
            loader.hide();
          });
        }
      } else {
        if (this.failed_filter) {
          this.getReportingEmployeesFailed({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: Math.floor(this.pageCount.failedPageCount / this.page_size),
            location: this.filter_values.location
              ? this.filter_values.location.name
              : null,
          }).then((res) => {
            this.results = res.data;
            this.start =
              Math.floor(this.pageCount.failedPageCount / this.page_size) - 10;
            this.end = Math.floor(
              this.pageCount.failedPageCount / this.page_size
            );
            this.pageNumber = Math.floor(
              this.pageCount.failedPageCount / this.page_size
            );
            loader.hide();
          });
        } else if (this.incomplete_filter) {
          this.getReportingIncompleteList({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            limit: this.page_size,
            page: this.pageCount.incompletePageCount / this.page_size,
            limit: this.page_size,
          }).then((res) => {
            this.results = res.data;
            this.start =
              Math.floor(this.pageCount.incompletePageCount / this.page_size) -
              10;
            this.end = Math.floor(
              this.pageCount.incompletePageCount / this.page_size
            );
            this.pageNumber = Math.floor(
              this.pageCount.incompletePageCount / this.page_size
            );
            loader.hide();
          });
        } else {
          this.getReportingResults({
            uid: this.user_doc.id,
            start_date: moment(this.startDate).format("YYYY-MM-DD"),
            end_date: moment(this.endDate).format("YYYY-MM-DD"),
            page: this.resultsLength / this.page_size,
            limit: this.page_size,
          }).then((res) => {
            this.results = res.data;
            this.start = this.resultsLength - 10;
            this.end = this.resultsLength;
            this.pageNumber = this.resultsLength / this.page_size;
            loader.hide();
          });
        }
      }
    },
    getPaginationInactive() {
      if (this.failed_filter) {
        return this.pageNumber === this.pageCount.failedPageCount;
      } else if (this.incomplete_filter) {
        return (
          this.pageNumber ===
            Math.ceil(this.pageCount.incompletePageCount / this.page_size) ||
          this.pageCount.incompletePageCount < this.page_size
        );
      } else {
        return (
          Math.ceil(this.pageNumber) ===
            Math.ceil(this.pageCount.resultsPageCount / this.page_size) ||
          this.pageCount.resultsPageCount < this.page_size
        );
      }
    },
    clearFilter() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      this.showClearBtn = false;
      this.getReportingResults({
        uid: this.user_doc.id,
        start_date: moment(this.filter_dates.today)
          .subtract(1, "d")
          .format("YYYY-MM-DD"),
        end_date: moment(this.filter_dates.today).format("YYYY-MM-DD"),
        page: 1,
        limit: this.page_size,
      }).then((res) => {
        this.results = res.data;
        this.pageNumber = 1;
        this.start = 1;
        this.end = 10;
        loader.hide();
      });
      this.filter_values = {};
    },
    formatPQA(pqa) {
      if (pqa) {
        let res = pqa.substring(5);
        return `${res[0].toUpperCase()}${res.slice(1)}`;
      }
    },
    disabledDates(date) {
      if (moment(date).isAfter(moment(Date.now()))) return true;
      else return false;
    },
    fetchNewAnalytics() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      this.getReportingResultsCounts({
        uid: this.user_doc.id,
        start_date: moment(this.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.endDate).format("YYYY-MM-DD"),
        location: this.filter_values.location
          ? this.filter_values.location.name
          : null,
      }).then((res) => {
        this.surveyCounts = {
          completed_count: res.data.completed,
          pass_count: res.data.pass,
          fail_count: res.data.fail,
          incomplete_count: res.data.incomplete,
        };
      });
      if (this.failed_filter) {
        this.getReportingEmployeesFailed({
          uid: this.user_doc.id,
          start_date: moment(this.filter_dates.today).format("YYYY-MM-DD"),
          limit: this.page_size,
          page: Math.floor(this.pageCount.failedPageCount / this.page_size),
          location: this.filter_values.location
            ? this.filter_values.location.name
            : null,
        }).then((res) => {
          this.results = res.data;
          this.start =
            Math.floor(this.pageCount.failedPageCount / this.page_size) - 10;
          this.end = Math.floor(
            this.pageCount.failedPageCount / this.page_size
          );
          this.pageNumber = Math.floor(
            this.pageCount.failedPageCount / this.page_size
          );
          loader.hide();
        });
      } else if (this.incomplete_filter) {
        this.getReportingIncompleteList({
          uid: this.user_doc.id,
          start_date: moment(this.startDate).format("YYYY-MM-DD"),
          end_date: moment(this.endDate).format("YYYY-MM-DD"),
          limit: this.page_size,
          page: Math.floor(this.pageCount.incompletePageCount / this.page_size),
          limit: this.page_size,
        }).then((res) => {
          this.results = res.data;
          this.start =
            Math.floor(this.pageCount.incompletePageCount / this.page_size) -
            10;
          this.end = Math.floor(
            this.pageCount.incompletePageCount / this.page_size
          );
          this.pageNumber = Math.floor(
            this.pageCount.incompletePageCount / this.page_size
          );
          loader.hide();
        });
      } else {
        this.getReportingResults({
          uid: this.user_doc.id,
          start_date: moment(this.startDate).format("YYYY-MM-DD"),
          end_date: moment(this.endDate).format("YYYY-MM-DD"),
          limit: 10,
          page: 1,
          location: this.filter_values.location
            ? this.filter_values.location.name
            : null,
        }).then((res) => {
          this.results = res.data;
          this.pageNumber = 1;
          this.start = 1;
          this.end = 10;
        });
      }
      this.getReportingResults({
        uid: this.user_doc.id,
        start_date: moment(this.startDate).format("YYYY-MM-DD"),
        end_date: moment(this.startDate).format("YYYY-MM-DD"),
        location: this.filter_values.location
          ? this.filter_values.location.name
          : null,
      }).then((res) => {
        this.resultsLength = res.data.length;
        this.$nextTick(async () => {
          new Chartist.Line(
            "#chart1",
            mappers.failedSurveysMapper(
              res.data,
              moment(this.startDate).format("YYYY-MM-DD"),
              moment(this.endDate).format("YYYY-MM-DD")
            ),
            {
              axisY: {
                onlyInteger: true,
              },
            }
          );

          new Chartist.Bar(
            "#chart2",
            mappers.completedSurveysMapper(
              res.data,
              moment(this.startDate).format("YYYY-MM-DD"),
              moment(this.endDate).format("YYYY-MM-DD")
            ),
            {
              axisY: {
                onlyInteger: true,
              },
            }
          );
        });
        loader.hide();
      });
    },
  },
};
</script>

<style scoped lang="scss">
.stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media screen and (max-width: 900px) {
    justify-content: space-between !important;
  }
  .card {
    width: 49%;
    position: relative;
    padding-top: 70px;
    transition: box-shadow 0.3s;
    cursor: default;
    &:hover {
      box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
    }
    img {
      position: absolute;
      z-index: 0;
      opacity: 0.1;
      height: 80%;
      right: 10%;
      top: 50%;
      transform: translateY(-50%);
    }
    .stat {
      font-size: 80px;
      color: #49c6d4;
      font-weight: 500;
      margin: 0;
      span {
        display: block;
        font-size: 16px;
        color: #132628;
        font-weight: 500;
        margin-top: -10px;
      }
    }
    @media screen and (max-width: 900px) {
      width: 49% !important;
    }
  }
  &.small {
    justify-content: flex-start;
    .card {
      width: auto !important;
      margin-right: 20px;
      padding-top: 30px;
      padding: 20px;
      @media screen and (max-width: 900px) {
        width: 49% !important;
        margin-right: 0;
      }
      .stat {
        font-size: 46px;
        span {
          font-size: 14px;
          margin-top: -5px;
        }
      }
    }
  }
}

.btn.small {
  padding: 7px 15px;
  font-size: 12px;
  text-transform: uppercase;
}

.filters {
  display: flex;
  align-items: center;
  padding: 10px;
  padding-bottom: 0;
  .btn {
    margin: 10px;
    transition: box-shadow 0.3s;
    background: #eaeaea;
    color: #767676;
    padding: 10px 20px;
    font-size: 13px;
    text-transform: uppercase;
    &.active {
      background-color: #00d97e;
      color: white;
    }
  }
  .filter {
    margin-right: 10px;
    margin-bottom: 10px;
    & > label {
      margin-bottom: 0;
      position: relative;
      top: 4px;
    }
  }
  .divide {
    margin-top: 10px;
    padding-top: 20px;
    border-top: 2px solid #eaeaea;
  }
}

.filter-icon {
  height: 15px;
}

.filter-icon:hover {
  cursor: pointer;
}

.down-arrow {
  transform: rotateZ(180deg);
}

.incomplete-filter,
.failed-filter {
  box-shadow: 0 0 30px #00bf6f;
}

.card-filter,
.card-filter:hover {
  cursor: pointer;
}

.chart2-label {
  display: flex;
  justify-content: row;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  p {
    margin: 0;
  }
}

.legend {
  display: flex;
  justify-content: row;
  .key {
    margin-left: 15px;
    display: flex;
    align-items: center;
    .color {
      height: 15px;
      width: 15px;
      margin-right: 5px;
    }
    p {
      margin: 0;
      &.pass {
        color: #00d97e;
      }
    }
  }
}

.ct-chart {
  max-height: 300px;
}

.date-range-container {
  display: flex;
  flex-direction: row;
}
</style>
